/* eslint eqeqeq: 'off' */
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from "react-redux";
import styles from './home.module.css';
import FM_bg_image from 'Assets/images/facilityMgmt_BG.jpg';
import thermometer from 'Assets/images/thermometer_half_white.svg';
import tools from 'Assets/images/tools_white.svg';
import clock from 'Assets/images/access_time_white.svg';
import { GetFacilityBackgroundImage } from '../../../action/invoiceAction';

class Home extends Component {
    
    constructor(props) {
        super(props);
        this.state = {  redirect : false, redirect_page:null, imagePreviewUrl:this.props.homeImage_response.FacilityImage};
        this.navigate = this.navigate.bind(this);
      }

    componentWillMount() {
        const l_Request = this.props.GetFacilityBackgroundImage();
        l_Request.then((result) => {
            this.setState({imagePreviewUrl:this.props.homeImage_response.FacilityImage});
        });
    }

    componentWillReceiveProps(nextProps) {
        if (this.props != nextProps) {
            if (nextProps.homeImage_response !== undefined && nextProps.homeImage_response !== null) {
                this.setState({imagePreviewUrl:nextProps.homeImage_response.FacilityImage});
            }
        }
    }
    
    navigate(event){
        this.props.onGetActivePagefromSubRouter(event.target.name);
        this.setState({redirect_page:event.target.name});
      }

    render() {
        let { userProfileDetails, getLicenseinfo, employeeTenantDetails, getTenantOrigin} = this.props;    
        let username = null;
        let allowTempAdjust = false, zoneDetails;
        let managecomfort = true, maintenancerequest = true, afterhours = true;
        let IsTenantFromWO = getTenantOrigin;
        let backgroundImage = (this.state.imagePreviewUrl ===undefined ||this.state.imagePreviewUrl ===null )? FM_bg_image : this.state.imagePreviewUrl;

        (userProfileDetails !== undefined && userProfileDetails.user_info !== undefined && userProfileDetails.user_info.firstName !== undefined) ?   //User Profile information
            username = userProfileDetails.user_info.firstName : username = "";


        if (this.state.redirect_page!==null) {
                switch (this.state.redirect_page) {
                  case "Comfort": return <Redirect to={"/FacilityManagement/Comfort"} />;
                  case "Maintenance": return <Redirect to={"/FacilityManagement/createMaintenance"} />;
                  case "After Hours": return <Redirect to={"/FacilityManagement/CreateAfterHoursRequest"} />;
                  default: return <Redirect to={"/FacilityManagement/home"} />;
                }
          }

        if (getLicenseinfo.licensedFeatures !== undefined && getLicenseinfo.licensedFeatures !== null && getLicenseinfo.licensedFeatures.length > 0){
            if (employeeTenantDetails !== undefined && employeeTenantDetails !== null){
                        var ZonesTemperatureCol = employeeTenantDetails.zonesTemperatureAdjustment;
                        if (ZonesTemperatureCol !== undefined && ZonesTemperatureCol !== null && ZonesTemperatureCol.length) {
                            var IsTemperatureAdjustmentEnabled = ZonesTemperatureCol.filter(x => x.allowTemperatureAdjustment === true);
                            allowTempAdjust = (IsTemperatureAdjustmentEnabled !== undefined && IsTemperatureAdjustmentEnabled !== null && IsTemperatureAdjustmentEnabled.length) ? true : false;
                        }
                        
                        zoneDetails = employeeTenantDetails.zoneIds.length;
                        if (getLicenseinfo.licensedFeatures[0].licensed && getLicenseinfo.licensedFeatures[1].licensed && allowTempAdjust == false){
                            if (IsTenantFromWO){
                                managecomfort = false; afterhours = false;   
                                return <Redirect to={"/FacilityManagement/Maintenance"} /> 
                            }
                            else {
                                managecomfort = false;
                            }
                        }
                        else if (getLicenseinfo.licensedFeatures[0].licensed && getLicenseinfo.licensedFeatures[1].licensed == false){
                            if(allowTempAdjust == true){

                                maintenancerequest = false;
                            }
                            else{
                                 return <Redirect to={"/FacilityManagement/AfterHours"}/>
                                }
                            }
                        else if (getLicenseinfo.licensedFeatures[0].licensed == false && getLicenseinfo.licensedFeatures[1].licensed){
                            return <Redirect to={"/FacilityManagement/Maintenance"} /> 
                        }
                }
            }



        return (
            <div style={{ backgroundImage: 'url('+backgroundImage+')' }} className={styles.homeContainer}>
            { 
                (managecomfort == true && zoneDetails == 0 && maintenancerequest == false) ? 
                 /* Display error message if no zones associated with the user */
                    
                    <div className={styles.messageContainer}>
                        <p className={styles.noZonesText}>Sorry, there are no zones associated to your account to allow you to make an After-Hours request.</p> 
                        <p className={styles.noZonesText}>Contact your property manager or building administrator to request access.</p>
                    </div> : 
                
                    <div className={styles.homeContent_box}>
                {/*Welcome Text */}

                        <p className={styles.welcomeText}>Hi {username}.</p>
                        <p className={styles.welcomeText}>What would you like to do today?</p> 

                {/* Navigation Buttons */}

                        {managecomfort ? <button name="Comfort" className={styles.comfort_Home_Button} onClick={this.navigate}> <img src={thermometer}  name="Comfort" alt="Trane Logo"  onClick={this.navigate} className={styles.home_screen_icons}/>Manage Comfort</button>:""}
                        {afterhours ? <button name="After Hours" className={styles.maintenance_Home_Button} onClick={this.navigate} > <img src={clock} alt="Trane Logo"   name="After Hours" onClick={this.navigate}  className={styles.home_screen_icons}/>New After-Hours Request</button>:""}
                        {maintenancerequest ? <button name="Maintenance" className={styles.AfterHours_Home_Button} onClick={this.navigate} > <img src={tools} alt="Trane Logo"  name="Maintenance"  onClick={this.navigate}  className={styles.home_screen_icons}/>New Maintenance Request</button>:""}
                    </div>
            } 
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        userProfileDetails: state.userDetailsRootReducer,
        getLicenseinfo: state.InstallationsRootReducer.TenantWorkOrderLicense,
        homeImage_response: state.InvoiceRootReducer,
        getTenantOrigin: state.facilityRootReducer.EmployeeTenantOrigin,
        employeeTenantDetails: state.FacilityRequestsEmployeeTenantDetails.EmployeeTenantDetails
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetFacilityBackgroundImage: () => dispatch(GetFacilityBackgroundImage()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
